export const testId = {
    addAllRights: "add-all-rights",
    addPermission: "add-permission",
    addRole: "add-role",
    deleteAllRights: "delete-all-rights",
    dialogsBandwidthByType: "dialogs-bandwidth-by-type",
    enableAll: "enable-all",
    invalidSumOfLimits: "sum-limits-validation-error",
    logging: "logging",
    permissions: "permissions",
    queues: "queues",
    turnOffAll: "turn-off-all"
} as const
